module.exports = __webpack_public_path__ + "static/media/health-chronic-disease-management.1d108630.svg";